import CONSTANTS from "components/FallRegistration/utils/constants";
export default {
	title: "Advancing. Together. ",
	sections: [
		{
			title: "MEMBERSHIP",
			icon: "membership",
			items: [
				{ text: "Benefits of Membership", link: "/membership" },
				{ text: "Join or Renew", link: `${process.env.APP_URL}/membership/join` },
				{ text: "My Dashboard", link: `${process.env.APP_URL}/dashboard` },
				{ text: "Hear from Members", link: "/membership/testimonials" },
			],
		},

		{
			title: "GET INVOLVED",
			icon: "thumb",
			items: [
				{ text: "Physician Leadership Connect", subText: "Discussion Forum", link: "/community" },
				{
					text: "Mentorship",
					subText: "Help shape the next generation of leaders",
					link: "/membership/mentoring",
				},
				{ text: "The Vanguard", subText: "High-level programming & networking", link: "/programs/vanguard" },
			],
		},

		{
			title: "placeholder", //placeholder occupies space but is invisible
			// icon: "book",
			items: [
				{
					text: "Fellowship (FAAPL)",
					subText: "The highest level of Leadership Excellence & Commitment",
					link: "/credentials/fellowship",
				},
				{
					text: "Leape Award",
					subText: "Recognizing institutions and their leaders",
					link: "/leape-ahead-award",
				},
				{
					text: "Schenke Award",
					subText: "Recognizing individuals and their contributions",
					link: "/roger-schenke-award",
				},
			],
		},
		{
			title: "EVENTS",
			icon: "event",
			items: [
				// {
				// 	text: "Academies",
				// 	subText: "Collaborative learning online in 1-2 day advanced Intensives",
				// 	link: "/education/academies",
				// },
				// {
				// 	text: "Spring & Fall Institutes",
				// 	subText: "AAPL's famous in-person learning and networking events",
				// 	link: "/education/institutes",
				// },
				{
					text: `${CONSTANTS.FALL_YEAR} Fall Institute`,
					subText: `${CONSTANTS.FALL_DATES}, ${CONSTANTS.FALL_YEAR} in Scottsdale, Arizona`,
					link: "/fall-institute",
				},
				{
					text: "2026 Annual Leadership Conference",
					subText: "October, 22-25 2026 in Scottsdale, Arizona",
					link: "/conference",
				},
				{
					text: "Certified Physician Executive: Capstone",
					subText: "The culmination of your dedication and pursuit of leadership excellence",
					link: "/credentials/cpe-capstone",
				},
			],
		},
	],

	// side: {
	// 	title: "LIVE EVENTS",

	// 	subTitle: "event",
	// 	details: "The business podcast for physicians & health care leaders.",
	// 	buttonText: "Listen Now",
	// },
};
